import React from 'react';

const Header = () => {
  return (
    <header className="bg-white shadow-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4 space-x-reverse">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-indigo-700">SOS Children's Villages International</h1>
            </div>
            {/* Logo placeholder - replace with actual logo */}
            <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">SOS</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

